import React from "react";
import { useLanguage } from "../../../contexts";
import "./Privacy.scss";

const content = {
  es: {
    title: "Política de Privacidad – Sustemia",
    updated: "Última actualización: 2026",
    intro:
      "En Sustemia, estamos comprometidos con la protección de la privacidad y seguridad de la información de nuestros usuarios.",
    sections: [
      {
        title: "1. Datos Recopilados",
        body: "Recopilamos:",
        list: [
          "Datos personales (nombre, correo electrónico, etc.)",
          "Información de la empresa",
          "Datos de gestión ambiental (incidentes, auditorías, evaluaciones, registros)",
        ],
      },
      {
        title: "2. Finalidad",
        body: "Los datos se utilizan para:",
        list: [
          "Proveer y mejorar el servicio",
          "Gestionar la información ambiental",
          "Generar reportes y garantizar el cumplimiento normativo",
        ],
      },
      {
        title: "3. Base Legal",
        body: "El tratamiento de datos se basa en el consentimiento del usuario y la relación contractual con Sustemia.",
      },
      {
        title: "4. Transferencias Internacionales",
        body: "Los datos pueden ser almacenados y procesados en servidores ubicados en distintos países, conforme a los estándares internacionales de protección de datos.",
      },
      {
        title: "5. Derechos de los Usuarios",
        body: "Los usuarios pueden:",
        list: [
          "Acceder a sus datos",
          "Solicitar corrección",
          "Solicitar eliminación",
        ],
      },
      {
        title: "6. Seguridad",
        body: "Implementamos medidas técnicas y organizativas para proteger los datos.",
      },
      {
        title: "7. Responsabilidad del Usuario",
        body: "Los usuarios confirman que tienen autorización para cargar datos de terceros.",
      },
      {
        title: "8. Contacto",
        body: "sustemiaweb@gmail.com",
        isEmail: true,
      },
    ],
  },
  en: {
    title: "Privacy Policy – Sustemia",
    updated: "Last updated: 2026",
    intro:
      "At Sustemia, we are committed to protecting the privacy and security of our users' information.",
    sections: [
      {
        title: "1. Data Collected",
        body: "We collect:",
        list: [
          "Personal data (name, email, etc.)",
          "Company information",
          "Environmental management data (incidents, audits, evaluations, records)",
        ],
      },
      {
        title: "2. Purpose",
        body: "Data is used to:",
        list: [
          "Provide and improve the service",
          "Manage environmental information",
          "Generate reports and ensure regulatory compliance",
        ],
      },
      {
        title: "3. Legal Basis",
        body: "Data processing is based on user consent and the contractual relationship with Sustemia.",
      },
      {
        title: "4. International Transfers",
        body: "Data may be stored and processed in servers located in different countries, in accordance with international data protection standards.",
      },
      {
        title: "5. User Rights",
        body: "Users may:",
        list: [
          "Access their data",
          "Request correction",
          "Request deletion",
        ],
      },
      {
        title: "6. Security",
        body: "We implement technical and organizational measures to protect data.",
      },
      {
        title: "7. User Responsibility",
        body: "Users confirm they have authorization to upload third-party data.",
      },
      {
        title: "8. Contact",
        body: "support@sustemia.com",
        isEmail: true,
      },
    ],
  },
};

export function Privacy() {
  const { language } = useLanguage();
  const lang = content[language] || content.es;

  return (
    <div className="legal-page">
      <div className="legal-page__card">
        <h1 className="legal-page__title">{lang.title}</h1>
        <p className="legal-page__updated">{lang.updated}</p>
        <p className="legal-page__intro">{lang.intro}</p>
        <div className="legal-page__sections">
          {lang.sections.map((section, i) => (
            <div key={i} className="legal-page__section">
              <h2 className="legal-page__section-title">{section.title}</h2>
              {section.isEmail ? (
                <p className="legal-page__section-body">
                  <a href={`mailto:${section.body}`} className="legal-page__link">
                    {section.body}
                  </a>
                </p>
              ) : (
                <p className="legal-page__section-body">{section.body}</p>
              )}
              {section.list && (
                <ul className="legal-page__list">
                  {section.list.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
